import React from "react";
import { Route, Routes } from "react-router-dom";

import { ACCESS_REQUEST_DETAIL_SEGMENT } from "@helpers/constants";

import AccessRequestDetail from "./AccessRequestDetail";
import AccessRequestsTable from "./AccessRequestsTable";
import NewAccessRequestForm from "./NewAccessRequestForm";

type Props = { onRouteNotFound?: () => void };

export default class AccessRequests extends React.Component<Props> {
  render() {
    const { onRouteNotFound } = this.props;
    return (
      <Routes>
        <Route path="/" element={<AccessRequestsTable />} />
        <Route path="/new" element={<NewAccessRequestForm />} />
        <Route
          path={`/${ACCESS_REQUEST_DETAIL_SEGMENT}/:requestId/*`}
          element={<AccessRequestDetail />}
        />
        <Route
          path="*"
          element={
            onRouteNotFound ? (
              (() => {
                onRouteNotFound();
                return null;
              })()
            ) : (
              <p>404 Not Found</p>
            )
          }
        />
      </Routes>
    );
  }
}
